import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { Document } from "../../core/model/document";
import { Workflow } from "../../core/model/workflow";
import { WorkflowService } from "../../core/service/workflow.service";
import { DocumentService } from "../../core/service/document.service";

@Component({
  selector: "app-edit-check-list",
  templateUrl: "./edit-check-list.component.html",
  styleUrls: ["./edit-check-list.component.scss"],
})
export class EditCheckListComponent implements OnInit {
  @Input()
  set document(value: Document) {
    if (value) {
      this._document = {
        ...value,
        workflow: value.workflow ? { ...value.workflow } : new Workflow(),
      };
      this.cdr.detectChanges();
    }
  }
  get document(): Document {
    return this._document;
  }

  private _document: Document;

  form2: FormGroup;
  pressButton: Boolean = false;
  loading = true;

  workflows: Workflow[];

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private _workflowService: WorkflowService,
    private _documentService: DocumentService,
    private cdr: ChangeDetectorRef
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      code: [null, Validators.compose([Validators.required])],
      obligatoire: [null, Validators.compose([Validators.required])],
      label: [
        null,
        [Validators.compose([Validators.required]), Validators.maxLength(255)],
      ],
      workflow: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getWorkflows();
  }

  getWorkflows() {
    this.loading = true;
    this._workflowService.getAllWorkflows().subscribe(
      (data) => {
        this.workflows = data;
        this.loading = false;
        this.cdr.detectChanges();
      },
      (error) => {
        console.log(error);
        this.loading = false;
        this.cdr.detectChanges();
      }
    );
  }

  save(): void {
    this.document.active = true;
    this.document.code = this.document.code.replace(" ", "_");

    const selected = (this.workflows || []).find(
      (w) => w.id === this.document.workflow.id
    );
    if (selected) {
      this.document.workflow = { ...selected };
    }

    this.pressButton = true;
    this._documentService
      .update(this.document)
      .pipe(first())
      .subscribe(
        () => {
          this.pressButton = false;
          this.activeModal.close(this.document);
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
